import { Box, CircularProgress, FormControl, FormControlLabel, FormLabel, Input, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack } from "@mui/material";
import { useState } from "react";
import { checkDoublePattern, checkMinutesPattern } from "../../utils/commons";
import { instance } from "../../utils/axios-config";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/Auth";
import ModalInfo from "../ModalInfo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";   //Calendario en español (adapterLocale="es")

const FormCaracteristicasCultivoComponent = ({position, setPosition, state, setState}) => {

    const {sessionToken} = useAuth();
    const {id} = useParams();
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [ errorMsg, setErrorMsg ] = useState({title: "¡Vaya! Parece que algo ha ido mal.", content: "Algo ha fallado al intentar crear el sector. Por favor, vuelve a intentarlo más tarde."});
    const [open, setOpen] = useState(false);
    const [ errorDates, setErrorDates ] = useState(false);

    const handleNext = (e) => {
        e.preventDefault();
        if(validateForm()){
            setPosition(2);
        }
    }

    const handlePrev = (e) => {
        e.preventDefault();
        setPosition(0);
    }

    const handleChangeCultivo = (e) => {

        if(e === "olivar"){
            setState({...state, tipoCultivo: e});
        }else{
            setState({...state, tipoCultivo: e, seto: ""});
        }
    }

    const handleChangeTipoCultivoTomate = (e) => {
        setState({...state, tipoCultivoTomate: e});
    }

    const handleChangeEncalado = (e) => {

        if(e === "N"){
            setState({...state, encalado: e, dosisEncalado: "", fechaEncalado: "", fechaDesencalado: "", pendienteCubierta: ""});
        } else {
            setState({...state, encalado: e});
        }

    }


    const handleChangeSuperficieSector = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, superficieSector: e});
        }
    }

    const handleFechaSiembra = (sc, ec) => {
        setState({...state, fechaSiembra: sc});
        //setFechaSiembra(sc);
        //DateValidation(sc, ec);
    }

    const handleFechaCubricion = (sc, ec) => {
        setState({...state, fechaCubricion: sc});
        //setFechaCubricion(ec);
        //DateValidation(sc, ec);
    }

    const handleFechaFinCampaña = (sc, ec) => {
        setState({...state, fechaFinCampaña: sc});
        //setFechaFinCampaña(ec);
        //DateValidation(sc, ec);
    }

    const handleFechaEncalado = (sc, ec) => {
        setState({...state, fechaEncalado: sc});
        //setFechaCubricion(ec);
        //DateValidation(sc, ec);
    }

    const handleFechaDesencalado = (sc, ec) => {
        setState({...state, fechaDesencalado: sc});
        //setFechaCubricion(ec);
        //DateValidation(sc, ec);
    }

    const validateForm = () =>{

        setErrors({});
        let inputIds = "";
        let valid = true;

        if(state.tipoCultivo === undefined || state.tipoCultivo === ''){
            setErrors(errors => ({...errors, errorTipoCultivo: true, errorTipoCultivoMsg: ""}));
            inputIds = inputIds ? inputIds +",tipoCultivo" : "tipoCultivo";
            valid = false;
        }else if(state.tipoPlantacion === "Secano" && state.tipoCultivo !== "olivar" && state.tipoCultivo !== "citricos"){
            //Puede pasar si se elige fresa o tomate y después se vuelve atrás y se cambia a secano
            setErrors(errors => ({...errors, errorTipoCultivo: true, errorTipoCultivoMsg: "En secano solo se puede elegir olivar o cítricos."}));
            inputIds = inputIds ? inputIds +",tipoCultivo" : "tipoCultivo";
            valid = false;
        }else if(state.tipoCultivo === "olivar"){
            if(state.seto === undefined || state.seto === ''){
                setErrors(errors => ({...errors, errorSeto: true, errorSetoMsg: "Debes elegir si el olivar es en seto o no."}));
                inputIds = inputIds ? inputIds +",seto" : "seto";
                valid = false;
            }
        }

        if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && (state.distanciaArboles === undefined || state.distanciaArboles === '')){
            setErrors(errors => ({...errors, errorDistanciaArboles: true, errorDistanciaArbolesMsg: ""}));
            inputIds = inputIds ? inputIds +",distanciaArboles" : "distanciaArboles";
            valid = false;
        }else if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && !(checkDoublePattern(state.distanciaArboles))){
            setErrors(errors => ({...errors, errorDistanciaArboles: true, errorDistanciaArbolesMsg: "Debe ser un valor numérico."}));
            inputIds = inputIds ? inputIds +",distanciaArboles" : "distanciaArboles";
            valid = false;
        }

        if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && (state.distanciaLineas === undefined || state.distanciaLineas === '')){
            setErrors(errors => ({...errors, errorDistanciaLineas: true, errorDistanciaLineasMsg: ""}));
            inputIds = inputIds ? inputIds +",distanciaLineas" : "distanciaLineas";
            valid = false;
        }else if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && !(checkDoublePattern(state.distanciaLineas))){
            setErrors(errors => ({...errors, errorDistanciaLineas: true, errorDistanciaLineasMsg: "Debe ser un valor numérico."}));
            inputIds = inputIds ? inputIds +",distanciaLineas" : "distanciaLineas";
            valid = false;
        }

        if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && (state.diametroCopa === undefined || state.diametroCopa === '')){
            setErrors(errors => ({...errors, errorDiametroCopa: true, errorDiametroCopaMsg: ""}));
            inputIds = inputIds ? inputIds +",diametroCopa" : "diametroCopa";
            valid = false;
        }else if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && !(checkDoublePattern(state.diametroCopa))){
            setErrors(errors => ({...errors, errorDiametroCopa: true, errorDiametroCopaMsg: "Debe ser un valor numérico."}));
            inputIds = inputIds ? inputIds +",diametroCopa" : "diametroCopa";
            valid = false;
        }

        //Fechas de campaña: siembra y fin (fresa y tomate) y cubrición (fresa). Formato 'YYYY-MM-DD';
        //si se borra el selector llega "Invalid Date". Orden: siembra <= cubrición <= fin.
        if(state.tipoCultivo === "fresa" || state.tipoCultivo === "tomate"){
            const fechaValida = (f) => /^\d{4}-\d{2}-\d{2}$/.test(f || '') && dayjs(f).isValid();
            const fechas = [["fechaSiembra", "errorFechaSiembra", "la fecha de siembra"], ["fechaFinCampaña", "errorFechaFinCampana", "la fecha de fin de campaña"]];
            if(state.tipoCultivo === "fresa"){
                fechas.splice(1, 0, ["fechaCubricion", "errorFechaCubricion", "la fecha de cubrición"]);
            }

            let fechasOk = true;
            fechas.forEach(([campo, error, nombre]) => {
                if(!fechaValida(state[campo])){
                    setErrors(errors => ({...errors, [error]: true, [error + "Msg"]: "Debe indicar " + nombre + "."}));
                    inputIds = inputIds ? inputIds + "," + campo : campo;
                    fechasOk = false;
                    valid = false;
                }
            });

            if(fechasOk && state.tipoCultivo === "fresa" && state.fechaCubricion < state.fechaSiembra){
                setErrors(errors => ({...errors, errorFechaCubricion: true, errorFechaCubricionMsg: "La fecha de cubrición no puede ser anterior a la de siembra."}));
                inputIds = inputIds ? inputIds + ",fechaCubricion" : "fechaCubricion";
                valid = false;
            }
            if(fechasOk && state.fechaFinCampaña <= (state.tipoCultivo === "fresa" ? state.fechaCubricion : state.fechaSiembra)){
                setErrors(errors => ({...errors, errorFechaFinCampana: true, errorFechaFinCampanaMsg: "La fecha de fin de campaña debe ser posterior a la de " + (state.tipoCultivo === "fresa" ? "cubrición." : "siembra.")}));
                inputIds = inputIds ? inputIds + ",fechaFinCampaña" : "fechaFinCampaña";
                valid = false;
            }

            //Tomate: hay que indicar si hay encalado
            if(state.tipoCultivo === "tomate" && state.encalado !== "S" && state.encalado !== "N"){
                setErrors(errors => ({...errors, errorencalado: true, errorencaladoMsg: "Debe indicar si se aplica encalado."}));
                inputIds = inputIds ? inputIds + ",encalado" : "encalado";
                valid = false;
            }

            //Tomate con encalado: dosis > 0, pendiente de cubierta (0-90 grados) y fechas de encalado y desencalado en orden
            if(state.tipoCultivo === "tomate" && state.encalado === "S"){
                const numero = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : null; };
                const dosis = numero(state.dosisEncalado);
                if(dosis === null || dosis <= 0){
                    setErrors(errors => ({...errors, errordosisEncalado: true, errordosisEncaladoMsg: "Debe indicar una dosis mayor que 0."}));
                    inputIds = inputIds ? inputIds + ",dosisEncalado" : "dosisEncalado";
                    valid = false;
                }
                const pendiente = numero(state.pendienteCubierta);
                if(pendiente === null || pendiente < 0 || pendiente > 90){
                    setErrors(errors => ({...errors, errorpendienteCubierta: true, errorpendienteCubiertaMsg: "Debe indicar una pendiente entre 0 y 90 grados."}));
                    inputIds = inputIds ? inputIds + ",pendienteCubierta" : "pendienteCubierta";
                    valid = false;
                }

                let encaladoOk = true;
                [["fechaEncalado", "errorFechaEncalado", "la fecha de encalado"], ["fechaDesencalado", "errorFechaDesencalado", "la fecha de desencalado"]].forEach(([campo, error, nombre]) => {
                    if(!fechaValida(state[campo])){
                        setErrors(errors => ({...errors, [error]: true, [error + "Msg"]: "Debe indicar " + nombre + "."}));
                        inputIds = inputIds ? inputIds + "," + campo : campo;
                        encaladoOk = false;
                        valid = false;
                    }
                });
                if(encaladoOk && state.fechaDesencalado <= state.fechaEncalado){
                    setErrors(errors => ({...errors, errorFechaDesencalado: true, errorFechaDesencaladoMsg: "La fecha de desencalado debe ser posterior a la de encalado."}));
                    inputIds = inputIds ? inputIds + ",fechaDesencalado" : "fechaDesencalado";
                    valid = false;
                }
            }
        }

        if((state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") && (state.tipoPlantacion === "Secano")){
            if(state.superficieSector === undefined || state.superficieSector === ''){
                setErrors(errors => ({...errors, errorSuperficieSector: true, errorSuperficieSectorMsg: ""}));
                inputIds = inputIds ? inputIds +",superficieSector" : "superficieSector";
                valid = false;
            }else if(!(checkDoublePattern(state.superficieSector))){
                setErrors(errors => ({...errors, errorSuperficieSector: true, errorSuperficieSectorMsg: "Debe ser un valor numérico."}));
                inputIds = inputIds ? inputIds +",superficieSector" : "superficieSector";
                valid = false;
            }
        }

        if(inputIds !== ""){
            try{
                let elem = document.getElementById(inputIds.split(",")[0]);
                elem.scrollIntoView({behavior: "smooth"});
                elem.focus();
            }catch(err){

            }
        }
        return valid;
    }

    const formatStateData = () => {
        let data = {
            nombre: state.nombre,
            tipoUsuario: state.tipoUsuario,
            tipoPlantacion: state.tipoPlantacion,
            tipoCultivo: state.tipoCultivo,
            distanciaArboles: parseFloat(state.distanciaArboles?.replace(',', '.')),
            distanciaLineas: parseFloat(state.distanciaLineas?.replace(',', '.')),
            diametroCopa: parseFloat(state.diametroCopa?.replace(',', '.')),
            superficieSector: parseFloat(state.superficieSector?.replace(',', '.')),
            seto: state.seto === "true" ? true : state.seto === "false" ? false : null,
            codigoEstacion: state.codigoEstacion,
            idEstacion: state.idEstacion,
            fechaSiembra: state.fechaSiembra,
            fechaFinCampaña: state.fechaFinCampaña,
            fechaCubricion: state.fechaCubricion,
            tipoCultivoTomate: state.tipoCultivoTomate,
            encalado: state.encalado === "S" ? 1 : 0,   //Igual que en FormEnd (el selector usa "S"/"N")
            dosisEncalado: parseFloat(state.dosisEncalado?.replace(',', '.')),
            fechaEncalado: state.fechaEncalado,
            fechaDesencalado: state.fechaDesencalado,
            pendienteCubierta: parseFloat(state.pendienteCubierta?.replace(',', '.'))
        };

        return data;
    }

    const handleSend = async (e) => {
        e.preventDefault();
        if(validateForm()){
            try {
                setLoading(true);
                const data = formatStateData();
                instance.defaults.headers.common = {'Authorization': `Bearer ${sessionToken}`}
                await instance.post(`/sectores/create-sector/${id}`, data).then(() => {
                    setLoading(false);
                    navigate("/listaSectores/" + id, {state: {type: "action-new", text: "Se ha creado el sector correctamente."}});
                });
            } catch (error) {
                if(error.response?.data.message === "error historico"){
                    setErrorMsg((prevErrorMsg) => ({
                        ...prevErrorMsg,
                        content: "Se ha producido un error al intentar recuperar el histórico de datos climáticos de la estación asociada. Puede deberse a una indisponibilidad temporal del servicio meteorológico o a que se han creado varios sectores en el mismo minuto. Por favor, inténtelo de nuevo en unos minutos."
                    }));
                }else if(error.response?.data.message === "error rosetta"){
                    setErrorMsg((prevErrorMsg) => ({
                        ...prevErrorMsg,
                        content: "Se ha producido un error al intentar realizar el cálculo a partir del análisis del suelo. Puede deberse a una indisponibilidad temporal del servicio externo que hace el cálculo. Por favor, inténtelo de nuevo más tarde o elija otra estrategia de captura de datos del suelo."
                    }));
                }else{
                    setErrorMsg((prevErrorMsg) => ({
                        ...prevErrorMsg,
                        content: "Algo ha fallado al intentar crear el sector. Por favor, vuelve a intentarlo más tarde."
                    }));
                }
                setOpen(true);
                setLoading(false);
            }
        }
    }

    return(
        <>
        <Box className={position !== 1 && 'hide'}>
            <h2>Características del Cultivo</h2>

                <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="tipoCultivo">Tipo de cultivo*</InputLabel>
                            <Select
                                className="t4b-finca-sector-inputs"
                                id="tipoCultivo"
                                label="tipoCultivo"
                                value={state.tipoCultivo}
                                onChange={(e) => handleChangeCultivo(e.target.value)}
                                required
                                error={errors.errorTipoCultivo}
                            >
                                <MenuItem value="citricos">Cítricos</MenuItem>
                                <MenuItem value="olivar">Olivar</MenuItem>
                                {/* Fresa y tomate solo en regadío */}
                                {state.tipoPlantacion !== "Secano" && <MenuItem value="fresa">Fresa</MenuItem>}
                                {state.tipoPlantacion !== "Secano" && <MenuItem value="tomate">Tomate</MenuItem>}
                            </Select>

                            {errors.errorTipoCultivoMsg && <div className="errorInput">{errors.errorTipoCultivoMsg}</div>}

                </FormControl>

                {(state.tipoCultivo === "fresa" || state.tipoCultivo === "tomate")  &&

                    <>
                        <div style={{marginBottom: "30px"}}>
                            <div className="avanzado-dates"></div>

                                <FormControl sx={{width: "100%", marginTop: "30px", marginBottom: "10px"}} variant="standard">
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DatePicker
                                            label="Fecha de siembra*"
                                            id="fecha-siembra"
                                            value={state.fechaSiembra ? dayjs(state.fechaSiembra) : null}
                                            slotProps={{
                                                textField: {
                                                id: "fechaSiembra",
                                                error: errorDates || !!errors.errorFechaSiembra,
                                                helperText: errors.errorFechaSiembraMsg,
                                                },
                                            }}
                                            onChange={(newValue) => {
                                                const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
                                                handleFechaSiembra(selectedDate, state.fechaSiembra);
                                            }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>

                                {(state.tipoCultivo === "fresa")  &&
                                <FormControl sx={{width: "100%", marginTop: "30px", marginBottom: "10px"}} variant="standard">
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DatePicker
                                            label="Fecha de cubrición*"
                                            id="fecha-cubricion"
                                            value={state.fechaCubricion ? dayjs(state.fechaCubricion) : null}
                                            slotProps={{
                                                textField: {
                                                id: "fechaCubricion",
                                                error: errorDates || !!errors.errorFechaCubricion,
                                                helperText: errors.errorFechaCubricionMsg,
                                                },
                                            }}
                                            onChange={(newValue) => {
                                                const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
                                                handleFechaCubricion(selectedDate, state.fechaCubricion);
                                            }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                                }

                                <FormControl sx={{width: "100%", marginTop: "30px", marginBottom: "10px"}} variant="standard">
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DatePicker
                                            label="Fecha fin de campaña (aprox)*"
                                            id="fecha-fin-campaña"
                                            value={state.fechaFinCampaña ? dayjs(state.fechaFinCampaña) : null}
                                            slotProps={{
                                                textField: {
                                                id: "fechaFinCampaña",
                                                error: errorDates || !!errors.errorFechaFinCampana,
                                                helperText: errors.errorFechaFinCampanaMsg,
                                                },
                                            }}
                                            onChange={(newValue) => {
                                                const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
                                                handleFechaFinCampaña(selectedDate, state.fechaFinCampaña);
                                            }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>

                        </div>
                    </>

                }


                {(state.tipoCultivo === "tomate")  &&
                <>

{/*                     <FormControl sx={{width: "100%", marginBottom: "20px"}} className="radio-green" variant="standard">
                        <FormLabel htmlFor="tipoCultivoTomate">Tipo de cultivo*</FormLabel>
                        <RadioGroup
                            name="tipoCultivoTomate"
                            id="tipoCultivoTomate"
                            value={state.tipoCultivoTomate}
                            onChange={(e) => handleChangeTipoCultivoTomate(e.target.value)}
                            error={errors.errortipoCultivoTomate ? "true" : ""}
                        >
                            <FormControlLabel value="A" control={<Radio />} label="Solanaceas" />
                            <FormControlLabel value="B" control={<Radio />} label="Cucurbitaceas" />
                        </RadioGroup>
                        {errors.errortipoCultivoTomateMsg && <div className="errorMsg">{errors.errortipoCultivoTomateMsg}</div>}
                    </FormControl> */}

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} className="radio-green" variant="standard">
                        <FormLabel htmlFor="encalado">Encalado*</FormLabel>
                        <RadioGroup
                            name="encalado"
                            id="encalado"
                            value={state.encalado}
                            onChange={(e) => handleChangeEncalado(e.target.value)}
                            error={errors.errorencalado ? "true" : ""}
                        >
                            <FormControlLabel value="N" control={<Radio />} label="NO" />
                            <FormControlLabel value="S" control={<Radio />} label="SÍ" />
                        </RadioGroup>
                        {errors.errorencaladoMsg && <div className="errorMsg">{errors.errorencaladoMsg}</div>}
                    </FormControl>

                    {state.encalado === "S" &&
                    <>

                        <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                <InputLabel htmlFor="dosisEncalado">kg de producto por cada 100 litros de agua*</InputLabel>
                                <Input
                                    id="dosisEncalado"
                                    className="t4b-finca-sector-inputs"
                                    label="kg de producto por cada 100 litros de agua"
                                    value={state.dosisEncalado || ""}
                                    onChange={(e) => {
                                        if(checkDoublePattern(e.target.value)){
                                            setState({...state, dosisEncalado: e.target.value});
                                        }
                                    }}
                                    required
                                    name="dosisEncalado"
                                    error={errors.errordosisEncalado}
                                />
                                {errors && errors.errordosisEncaladoMsg && <div className="errorMsg">{errors.errordosisEncaladoMsg}</div>}
                        </FormControl>

                        <FormControl sx={{width: "100%", marginTop: "30px", marginBottom: "10px"}} variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                <DatePicker
                                    label="Fecha de encalado*"
                                    id="fecha-encalado"
                                    value={state.fechaEncalado ? dayjs(state.fechaEncalado) : null}
                                    slotProps={{
                                        textField: {
                                        id: "fechaEncalado",
                                        error: errorDates || !!errors.errorFechaEncalado,
                                        helperText: errors.errorFechaEncaladoMsg,
                                        },
                                    }}
                                    onChange={(newValue) => {
                                        const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
                                        handleFechaEncalado(selectedDate, state.fechaEncalado);
                                    }}
                                />
                            </LocalizationProvider>
                        </FormControl>

                        <FormControl sx={{width: "100%", marginTop: "30px", marginBottom: "10px"}} variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                <DatePicker
                                    label="Fecha de desencalado*"
                                    id="fecha-desencalado"
                                    value={state.fechaDesencalado ? dayjs(state.fechaDesencalado) : null}
                                    slotProps={{
                                        textField: {
                                        id: "fechaDesencalado",
                                        error: errorDates || !!errors.errorFechaDesencalado,
                                        helperText: errors.errorFechaDesencaladoMsg,
                                        },
                                    }}
                                    onChange={(newValue) => {
                                        const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
                                        handleFechaDesencalado(selectedDate, state.fechaDesencalado);
                                    }}
                                />
                            </LocalizationProvider>
                        </FormControl>

                        <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                <InputLabel htmlFor="pendienteCubierta">Pendiente de la cubierta (grados)*</InputLabel>
                                <Input
                                    id="pendienteCubierta"
                                    className="t4b-finca-sector-inputs"
                                    label="Pendiente de la cubierta (grados)"
                                    value={state.pendienteCubierta || ""}
                                    onChange={(e) => {
                                        if(checkDoublePattern(e.target.value)){
                                            setState({...state, pendienteCubierta: e.target.value});
                                        }
                                    }}
                                    required
                                    name="pendienteCubierta"
                                    error={errors.errorpendienteCubierta}
                                />
                                {errors && errors.errorpendienteCubiertaMsg && <div className="errorMsg">{errors.errorpendienteCubiertaMsg}</div>}
                        </FormControl>

                    </>
                    }        

                </>
                }



                {(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos")  &&
                <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="distanciaArboles">Marco de Plantación (metros entre árbol)*</InputLabel>
                            <Input
                                id="distanciaArboles"
                                className="t4b-finca-sector-inputs"
                                label="Distancia entre árboles"
                                value={state.distanciaArboles}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, distanciaArboles: e.target.value});
                                    }
                                }}
                                required
                                name="distanciaArboles"
                                error={errors.errorDistanciaArboles}
                            />
                            {errors.errorDistanciaArbolesMsg && <div className="errorInput">{errors.errorDistanciaArbolesMsg}</div>}
                </FormControl>
                }

                {(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos")  &&
                <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="distanciaLineas">Marco de Plantación (metros entre líneas de árboles)*</InputLabel>
                            <Input
                                id="distanciaLineas"
                                className="t4b-finca-sector-inputs"
                                label="Distancia entre líneas"
                                value={state.distanciaLineas}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, distanciaLineas: e.target.value});
                                    }
                                }}
                                required
                                name="distanciaLineas"
                                error={errors.errorDistanciaLineas}
                            />
                            {errors.errorDistanciaLineasMsg && <div className="errorInput">{errors.errorDistanciaLineasMsg}</div>}
                </FormControl>
                }

                {(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos")  &&
                <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="diametroCopa">Diámetro de Copa (metros)*</InputLabel>
                            <Input
                                id="diametroCopa"
                                className="t4b-finca-sector-inputs"
                                label="Diámetro de Copa"
                                value={state.diametroCopa}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, diametroCopa: e.target.value});
                                    }
                                }}
                                required
                                name="diametroCopa"
                                error={errors.errorDiametroCopa}
                            />
                            {errors.errorDiametroCopaMsg && <div className="errorInput">{errors.errorDiametroCopaMsg}</div>}
                </FormControl>
                }

                {state.tipoCultivo === "olivar" &&
                    <FormControl sx={{width: "100%", marginBottom: "20px"}} className="radio-green" variant="standard">
                        <FormLabel htmlFor="seto">Seto*</FormLabel>
                        <RadioGroup
                            name="seto"
                            value={state.seto}
                            onChange={(e) => setState({...state, seto: e.target.value})}
                            error={errors.errorSeto}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="En seto" />
                            <FormControlLabel value="false" control={<Radio />} label="Sin seto" />
                        </RadioGroup>
                        {errors.errorSetoMsg && <div className="errorMsg">{errors.errorSetoMsg}</div>}
                    </FormControl>
                }

                {state.tipoPlantacion === "Secano" &&

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                        <InputLabel htmlFor="superficieSector">Superficie del Sector (hectáreas)*</InputLabel>
                        <Input
                            id="superficieSector"
                            className="t4b-finca-sector-inputs"
                            label="Superficie Sector"
                            value={state.superficieSector}
                            onChange={(e) => handleChangeSuperficieSector(e.target.value)}
                            required
                            name="superficieSector"
                            error={errors.errorSuperficieSector}
                        />
                        {errors.errorSuperficieSectorMsg && <div className="errorInput">{errors.errorSuperficieSectorMsg}</div>}
                    </FormControl>

                }

                {loading ?
                    <Box align="center" sx={{my: 2}}>
                        <CircularProgress />
                    </Box>
                    :
                    <Stack spacing={2} direction="row" justifyContent="space-between" className="tic4bio-sectores-btns">
                        <button className="btn white" onClick={(e) => handlePrev(e)}>Anterior</button>
                        {state.tipoPlantacion === "Secano" &&
                            <button className="btn green" onClick={(e) => handleSend(e)} style={{margin: "16px 0"}}>Crear</button>
                        }
                        {state.tipoPlantacion !== "Secano" &&
                            <button className="btn green" onClick={(e) => handleNext(e)} style={{margin: "16px 0"}}>Siguiente</button>
                        }
                    </Stack>
                }

            </Box>
            <ModalInfo open={open} setOpen={setOpen} contentTitle={errorMsg.title} contentText={errorMsg.content}/>
        </>
    );
}

export default FormCaracteristicasCultivoComponent;